import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/edit/')({
  component: EditPage,
})

function EditPage() {
  return (
    <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight text-primary">Image Editing</h1>
      <p className="text-sm text-muted-foreground">
        The editing playground will live here. Once the Comfy workflows arrive, you will be able to mask, paint, and
        remix images with the same streamlined queue experience.
      </p>
    </div>
  )
}
